import { ColoredMaterialPreview } from "components/search-results/preview/ColoredMaterialPreview";
import { useDemoMaterials } from "hooks/demo-materials";
import {
  MaterialShowcaseView,
  type TileImageRenderer,
} from "./MaterialShowcase";

interface MaterialShowcaseProps {
  isLogin?: boolean;
}

const renderMaterialImage: TileImageRenderer = ({
  material,
  isPreviewOpen,
  onClosePreview,
  onOpenDetail,
}) => (
  <ColoredMaterialPreview
    width="100%"
    height="100%"
    material={material}
    imageType="SQUARE"
    isOpenPreviewImage={isPreviewOpen}
    onClosePreview={onClosePreview}
    onOpenDetail={onOpenDetail}
    usePublicEndpoint
  />
);

/** Data-fetching wrapper — uses auth hooks, NOT safe for Storybook. */
export const MaterialShowcase = ({ isLogin }: MaterialShowcaseProps) => {
  const [result, , isLoading] = useDemoMaterials();
  return (
    <MaterialShowcaseView
      materials={result?.results}
      loading={isLoading}
      isLogin={isLogin}
      renderImage={renderMaterialImage}
    />
  );
};
